import Keycloak from 'keycloak-js';
import config from '@/config/params';
import axios from 'axios';
import store from '@/store/store.js';

const MSG_AUTH_USER = 'keycloak: Пользователь авторизован';
const MSG_AUTH_FAIL = 'keycloak: Ошибка аутентификации';
const MSG_INIT_FAIL = 'keycloak: Недоступен сервис keycloak';
const MSG_TOKEN_UPDATE = 'keycloak: Токен обновлён';
const MSG_TOKEN_FAILED = 'keycloak: Не удалось обновить токен';

const keycloak = new Keycloak({
    url: config.keycloak.url,
    realm: config.keycloak.realm,
    clientId: config.keycloak.clientId,
    redirectUri: location.href,
});

const keycloakAuth = keycloak
    .init({
        onLoad: 'login-required',
        checkLoginIframe: config.keycloak.checkLoginIframe,
    })
    .then(auth => {
        if (!auth) {
            console.warn(MSG_AUTH_FAIL);
            return;
        }

        setAxiosToken(keycloak.token);

        const user = extractUser(keycloak.tokenParsed);
        saveUser(user);
        console.log(MSG_AUTH_USER, user);

        const intervalTimeout = 10000;
        keycloak.updateTokenInterval = setInterval(refreshToken, intervalTimeout);
    })
    .catch(error => {
        throw new Error(`${MSG_INIT_FAIL} \n ${error}`);
    });

/**
 * @returns {void}
 */
const refreshToken = async function() {
    try {
        const refreshed = await keycloak.updateToken(config.keycloak.updateTokenMinValidity);
        if (refreshed) {
            setAxiosToken(keycloak.token);
            console.log(MSG_TOKEN_UPDATE);
        }
    } catch (error) {
        keycloak.clearToken();
        console.log(MSG_TOKEN_FAILED, error);
    }
};

/**
 * @param {string} tokenParsed
 * @returns {{name, account: *}}
 */
const extractUser = function(tokenParsed) {
    return {
        name: tokenParsed.name,
        account: tokenParsed.preferred_username,
    };
};

/**
 * @param {string} token
 */
const setAxiosToken = function(token) {
    axios.defaults.headers['X-Access-Token'] = token;
};

/**
 * @param {object} user
 */
const saveUser = function(user) {
    if (store) {
        store.commit('setUser', user);
    }
};

export { keycloak, keycloakAuth };